module.exports = __webpack_public_path__ + "static/media/KARNATAKABANK.b4cf8f8d.svg";